import { NextPage } from 'next';
import Head from 'next/head';
import styled, { ThemeProvider } from 'styled-components';
import Footer from '../components/BrandSitesV2/common/Footer';
import { BrandSitesV2GlobalStyle, BrandSitesV2Theme } from '../components/BrandSitesV2/common/GlobalStyle';
import Header from '../components/BrandSitesV2/common/Header';
import StickyAppDownloadButton from '../components/BrandSitesV2/common/StickyAppDownloadButton';
import CardSection from '../components/BrandSitesV2/Store/CardSection';
import GoToStoreSection from '../components/BrandSitesV2/Store/GoToStoreSection';
import HeroSection from '../components/BrandSitesV2/Store/HeroSection';
import InfoSection from '../components/BrandSitesV2/Store/InfoSection';
import CommerceSection from '../components/BrandSitesV2/Store/CommerceSection';
import { GoogleAnalyticsBrandsiteScript } from '../components/GoogleAnanlytics';

const StorePage: NextPage = () => {
  return (
    <>
      <Head>
        <title>청소연구소 - 플러스샵 소개</title>
        <meta property="og:title" content="청소연구소 - 플러스샵 소개" />
        <meta
          name="description"
          content="청소연구소가 만든 안전하고 합리적인 생활용품, 청소용품을 플러스샵에서 만나보세요."
        />
        <meta
          property="og:description"
          content="청소연구소가 만든 안전하고 합리적인 생활용품, 청소용품을 플러스샵에서 만나보세요."
        />
        <meta
          name="keywords"
          content="청소연구소,청연스토어,플러스샵,생활용품,청소용품,주방세제,핸드워시,세정제,세제"
        />
        <meta
          name="og:keywords"
          content="청소연구소,청연스토어,플러스샵,생활용품,청소용품,주방세제,핸드워시,세정제,세제"
        />
        <meta property="og:url" content="https://www.cleaninglab.co.kr/store" />
        <link rel="canonical" href="https://www.cleaninglab.co.kr/store" />
        <meta
          property="og:image"
          content="https://cleanhome-web.cleaninglab.co.kr/brandsite/store/thumb.png"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="360" />
        <meta property="og:image:type" content="image/png" />
        <GoogleAnalyticsBrandsiteScript />
      </Head>
      <BrandSitesV2GlobalStyle />
      <ThemeProvider theme={BrandSitesV2Theme}>
        <Header />
        <Main>
          <HeroSection />
          {/* <InfoSection /> */}
          <CommerceSection />
          <StickyContainer>
            <CardSection />
            <GoToStoreSection />
            <StickyAppDownloadButton />
          </StickyContainer>
        </Main>
        <Footer />
      </ThemeProvider>
    </>
  );
};

export default StorePage;

const Main = styled.main``;

const StickyContainer = styled.div``;
